import {
  RouterProvider,
  createBrowserRouter,
} from "react-router-dom";
import "./App.css";
import { ThemeProvider } from "@mui/material";
import theme from "./assets/theme";
import { routerData } from "./utils/routes";



const router = createBrowserRouter(routerData, {
  basename: "",
  future: {
    v7_scrollRestoration: true,
  },
});

function App() {
  return (
    <ThemeProvider theme={theme}>
      <RouterProvider router={router} />
    </ThemeProvider>
  );
}

export default App;
